import { render } from "./ContactCreation.vue?vue&type=template&id=6fc9c032&ts=true"
import script from "./ContactCreation.vue?vue&type=script&lang=ts"
export * from "./ContactCreation.vue?vue&type=script&lang=ts"

import "./ContactCreation.vue?vue&type=style&index=0&id=6fc9c032&lang=scss"

import exportComponent from "/home/vsts/work/1/s/src/CRM/OutlookAddin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__